import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

const menuWrapperEl = document.querySelector('.component-menu .menu-wrapper');
const swiperRoot = document.querySelector('.component-menu [data-swiper="root"]');
const swiperButtonPrev = document.querySelector('.component-menu [data-swiper="button-prev"]');
const swiperButtonNext = document.querySelector('.component-menu [data-swiper="button-next"]');

if (menuWrapperEl) {
  menuWrapperEl.classList.add('position-relative');
  menuWrapperEl.classList.add('container');
  menuWrapperEl.classList.remove('menu-wrapper');

  swiperRoot.classList.add('swiper');
  swiperButtonPrev.classList.add('swiper-button-prev');
  swiperButtonNext.classList.add('swiper-button-next');
}

new Swiper('.component-menu .swiper', {
  modules: [Navigation],
  slidesPerView: 'auto',
  spaceBetween: 0,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});

const menu = document.getElementsByClassName('component-menu');
Array.from(menu).forEach((headerMenu) => {
  // toggle with link
  const headerMenuLinks = headerMenu.querySelectorAll('.js-toggle-link');
  headerMenuLinks.forEach(item => {
    item.addEventListener('click', function (e) {
      e.preventDefault();
      const currentItem = item.closest('li');
      const headerMenuItems = item.closest('ul').querySelectorAll(':scope > li');
      headerMenuItems.forEach(function(item) {
        if(this.currentItem !== item) {item.classList.remove('is-open');
        }else{
          item.classList.toggle('is-open');
          window.console.log(item);
        }
      }, { currentItem: currentItem })
    })
  })
  // toggle with icon
  const headerMenuIcons = headerMenu.querySelectorAll('.js-toggle-icon');
  headerMenuIcons.forEach(item => {
    item.addEventListener('click', function (e) {
      e.preventDefault();
      const currentItem = item.closest('li');
      const headerMenuItems = item.closest('ul').querySelectorAll(':scope > li');
      headerMenuItems.forEach(function(item) {
        if(this.currentItem !== item) {
          item.classList.remove('is-open');
        }else{
          item.classList.toggle('is-open');
        }
      }, { currentItem: currentItem })
    })
  })
})

// hide menu when clicked outside
// https://stackoverflow.com/questions/14188654/detect-click-outside-element-vanilla-javascript
var specifiedElement = document.querySelector('.component-menu');
document.addEventListener('click', function(event) {
  var isClickInside = specifiedElement.contains(event.target);
  if (!isClickInside) {
    const headerMenuItems = specifiedElement.querySelectorAll('.is-open');
    headerMenuItems.forEach(item => {
      item.classList.remove('is-open');
    })
  }
});
